import { createReducer } from '../../base/fsa/createReducer';
import {
    AlarmLogModel,
    AlarmState,
    ConfigModel,
    initialControlState,
} from './state';
import {
    controlSendErrorAction,
    mediaStatusUpdatedAction,
    setBellStatusAction,
    setDefaultAlarmStateAction,
    setIntercomInfoAction,
    setIntercomStatusAction,
    inputSendErrorAction,
    entityDeletedAction,
    entityCreatedAction,
    setEntityListAction,
    setInitialEntityListAction,
    entityUpdatedAction,
    setSoundStateAction,
    setScreenSaverStatusAction,
    setGroupControlsAction,
    setPasswordAction,
    setVersionAction,
    setLogAction,
    setRSSIAction,
    setUserLogAction,
    // setEnergyAnalyzer,
    setEnergyInfo,
    setEnergyUpdated,
    setEnergyAnalyzer,
    setMessageAction,
    setMessageStatusAction,
    setMessageNotification,
    setConnectionIconsAction,
    setReadAllTempFunc,
    setSoundPlayingStatusAction,
    setWorkerConfig,
    setSupervisorConfigListAction,
    setSupervisorConfigUpdateAction,
    setUserResetPassword,
    setTouchMessageAction,
    setPasswordActionV2,
    setPingTestAction,
    setTraceRouteAction,
    setMousePointerAction,
    setHomepageItemsActions,
    setTemporaryUserAction,
    setMatchStateAction,
    setExternalUsbAction,
    setTimezoneAction,
    setTimezoneOffsetAction,
    setSuntimeAction,
    setResetCountdown,
    setDetailedRFTest,
    setHardwareVersionCompatibility,
    setDeviceVersionListResponse,
    setSelectedBackgroundAction,
    setSystemRestartAction,
    setWorkerConfigPanelAction,
    setOnboardingListAction,
    setAuthenticatedWithPinCode,
    setResetCloudUserAlarmPassword,
    setCloudStatus,
    setCloudConnectionStatusAction,
    setRemoteUpdateConfig,
} from "./actions"

import { DoorModel } from '../../types/door';
import { ControlModel } from '../../types/control';

export const controlReducer = createReducer(initialControlState, handle => [
    handle(entityDeletedAction, (s, a) => {
        const key = a.payload.type + "List"
        const list = s[key] as { id: string }[]
        return {
            ...s,
            [key]: list.filter(e => e.id !== a.payload.id)
        }
    }),
    handle(entityCreatedAction, (s, a) => {
        const key = a.payload.type + "List"
        if (/*a.payload.type === 'virtualControl' ||*/ a.payload.type === "input" || a.payload.type === "inputType") {
            const r = a.payload.entity as { registered_by_system: boolean }
            if (r.registered_by_system) {
                return s
            }
        }

        if (a.payload.type === "door") {
            const door = a.payload.entity as DoorModel
            a.payload.entity = { ...door, toString: () => door.id }
        }

        return {
            ...s,
            [key]: [...s[key], a.payload.entity]
        }
    }),
    handle(setEntityListAction, (s, a) => {
        let key = a.payload.type

        if (a.payload.type !== "config") {
            key += "List"
        }

        return {
            ...s,
            [key]: a.payload.entities
        }
    }),
    handle(setInitialEntityListAction, (s, a) => {
        let key = a.payload.type

        if (a.payload.type !== "config") {
            key += "List"
        }

        if (a.payload.type === 'control') {
            const existingControls = s.controlList || [];
            const newControls = a.payload.entities as ControlModel[];
            
            if (existingControls.length > 0) {
                const mergedControls = newControls.map(newControl => {
                    const existing = existingControls.find(c => c.id === newControl.id);
                    if (existing && existing.isUpdating !== undefined) {
                        return existing;
                    }
                    return newControl;
                });
                
                return {
                    ...s,
                    [key]: mergedControls
                };
            }
        }

        return {
            ...s,
            [key]: a.payload.entities
        }
    }),
    handle(entityUpdatedAction, (s, a) => {
        if (a.payload.type === "mediaFile") {
            return s
        }

        if (a.payload.type === "config") {
            return {
                ...s,
                config: a.payload.entity as ConfigModel
            }
        }

        if (a.payload.type === "alarmTimer") {
            return {
                ...s,
                alarmTimer: a.payload.entity as any
            }
        }

        const key = a.payload.type + "List"
        // if (a.payload.type === 'virtualControl') {
        //     const r = a.payload.entity as VirtualControlModel;
        //     if (r.registered_by_system) {
        //         return s;
        //     }
        // }

        if (a.payload.type === "door") {
            const door = a.payload.entity as DoorModel
            a.payload.entity = { ...door, toString: () => door.id }
        }

        if (a.payload.type === "alarmState") {
            return {
                ...s,
                alarmState: {
                    ...s.alarmState,
                    default: {
                        ...s.alarmState.default,
                        // @ts-ignore
                        ...(a.payload.entity as AlarmState),
                        latest_log_list: a.payload.entity.latest_log_list
                            ? (a.payload.entity.latest_log_list as AlarmLogModel[])
                            : []
                    }
                }
            }
        }

        const list = s[key] as { id: string }[]
        return {
            ...s,
            [key]: list.map(e => {
                if (e.id === a.payload.entity.id) {
                    if (a.payload.type === "control" || a.payload.type === "input") {
                        return { ...e, isUpdating: false, ...a.payload.entity }
                    }
                    return a.payload.entity
                }

                return e
            })
        }
    }),

    // updates
    handle(controlSendErrorAction, (state, action) => {
        return {
            ...state,
            controlList: state.controlList.map(control => {
                if (control.id === action.payload.controlId) {
                    return { ...control, isUpdating: false, hasError: action.payload.hasError }
                }

                return control
            })
        }
    }),
    handle(inputSendErrorAction, (state, action) => {
        return {
            ...state,
            inputList: state.inputList.map(input => {
                if (input.id === action.payload.inputId) {
                    return { ...input, isUpdating: false, hasError: action.payload.hasError }
                }

                return input
            }),
            controlList: state.controlList.map(c => {
                if (c.id === action.payload.inputId) {
                    return { ...c, isUpdating: false, hasError: action.payload.hasError }
                }

                return c
            })
        }
    }),
    handle(mediaStatusUpdatedAction, (state, action) => {
        return {
            ...state,
            mediaStatus: action.payload
        }
    }),
    handle(setIntercomStatusAction, (state, action) => {
        return {
            ...state,
            intercomState: {
                ...state.intercomState,
                status: action.payload.status,
                is_incoming_call: action.payload.is_incoming_call,
                id: action.payload.id,
                name: action.payload.name,
                call_time: action.payload.call_time
            }
        }
    }),
    handle(setIntercomInfoAction, (state, action) => {
        return {
            ...state,
            intercomState: {
                ...state.intercomState,
                info: action.payload
            }
        }
    }),
    handle(setBellStatusAction, (state, action) => {
        return {
            ...state,
            bellStatus: action.payload
        }
    }),
    handle(setScreenSaverStatusAction, (state, action) => {
        return {
            ...state,
            screenSaverStatus: action.payload
        }
    }),
    handle(setDefaultAlarmStateAction, (state, action) => {
        return {
            ...state,
            alarmState: {
                ...state.alarmState,
                default: {
                    ...action.payload,
                    latest_log_list: action.payload.latest_log_list == null ? [] : action.payload.latest_log_list
                }
            }
        }
    }),
    handle(setSoundStateAction, (state, action) => {
        return {
            ...state,
            sound: action.payload
        }
    }),
    handle(setGroupControlsAction, (state, action) => {
        return {
            ...state,
            groupControlList: action.payload
        }
    }),
    handle(setPasswordAction, (state, action) => {
        return {
            ...state,
            passwordStatus: action.payload
        }
    }),
    handle(setPasswordActionV2, (state, action) => {
        return {
            ...state,
            passwordStatusV2: action.payload
        }
    }),
    handle(setVersionAction, (state, action) => {
        return {
            ...state,
            versionStatus: action.payload
        }
    }),
    handle(setLogAction, (state, action) => {
        return {
            ...state,
            logList: action.payload
        }
    }),
    handle(setUserLogAction, (state, action) => {
        return {
            ...state,
            userLogList: action.payload
        }
    }),
    handle(setConnectionIconsAction, (state, action) => {
        return {
            ...state,
            connectionIcons: action.payload
        }
    }),
    handle(setRSSIAction, (state, action) => {
        return {
            ...state,
            rssiStatus: action.payload
        }
    }),

    handle(setEnergyAnalyzer, (state, action) => {
        return {
            ...state,
            energyState: action.payload
        }
    }),

    handle(setEnergyInfo, (state, action) => {
        return {
            ...state,
            energyInfo: action.payload
        }
    }),

    handle(setEnergyUpdated, (state, action) => {
        return {
            ...state,
            energyUpdated: action.payload
        }
    }),
    handle(setMessageAction, (state, action) => {
        return {
            ...state,
            messageList: action.payload
        }
    }),
    handle(setMessageStatusAction, (state, action) => {
        return {
            ...state,
            messageStatus: action.payload
        }
    }),
    handle(setMessageNotification, (state, action) => {
        return {
            ...state,
            messageNotification: action.payload
        }
    }),

    handle(setReadAllTempFunc, (state, action) => {
        return {
            ...state,
            readAllTempFunc: action.payload
        }
    }),

    handle(setSupervisorConfigListAction, (s, a) => {
        let key = a.payload.type
        key += "List"
        return {
            ...s,
            [key]: a.payload.sup_config
        }
    }),

    handle(setSupervisorConfigUpdateAction, (s, a) => {
        const key = a.payload.type + "List"
        const list = s[key] as { id: string }[]
        return {
            ...s,
            [key]: list.map(e => {
                if (e.id === a.payload.sup_config.id) {
                    return a.payload.sup_config
                }
                return e
            })
        }
    }),

    handle(setWorkerConfig, (state, action) => {
        return {
            ...state,
            workerConfig: action.payload
        }
    }),

    handle(setUserResetPassword, (state, action) => {
        return {
            ...state,
            userResetPassword: action.payload
        }
    }),

    handle(setResetCloudUserAlarmPassword, (state, action) => {
        return {
            ...state,
            userResetPassword: {
                ...state.userResetPassword,
                user_name: action.payload,
                first_login: false,
            }
        }
    }),

    handle(setSoundPlayingStatusAction, (state, action) => {
        return {
            ...state,
            soundPlayingStatus: action.payload
        }
    }),

    handle(setTouchMessageAction, (state, action) => {
        return {
            ...state,
            touchMessageStatus: action.payload
        }
    }),

    handle(setPingTestAction, (state, action) => {
        return {
            ...state,
            pingTest: action.payload
        }
    }),

    handle(setTraceRouteAction, (state, action) => {
        return {
            ...state,
            traceRouteTest: action.payload
        }
    }),

    handle(setMatchStateAction, (state, action) => {
        return {
            ...state,
            matchState: action.payload
        }
    }),

    handle(setMousePointerAction, (state, action) => {
        return {
            ...state,
            mousePointerStatus: action.payload
        }
    }),

    handle(setHomepageItemsActions, (state, action) => {
        return {
            ...state,
            favoritesPage: action.payload
        }
    }),

    handle(setTemporaryUserAction, (state, action) => {
        return {
            ...state,
            temporaryUserStatus: action.payload
        }
    }),

    handle(setExternalUsbAction, (state, action) => {
        return {
            ...state,
            externalUsbStatus: action.payload
        }
    }),

    handle(setTimezoneAction, (state, action) => {
        return {
            ...state,
            timezoneList: action.payload
        }
    }),

    handle(setTimezoneOffsetAction, (state, action) => {
        return {
            ...state,
            timezoneOffset: action.payload
        }
    }),

    handle(setSuntimeAction, (state, action) => {
        return {
            ...state,
            suntime: action.payload
        }
    }),

    handle(setResetCountdown, (state, action) => {
        return {
            ...state,
            somResetCountdown: action.payload
        }
    }),

    handle(setDetailedRFTest, (state, action) => {
        return {
            ...state,
            detailedRFTestResponse: action.payload
        }
    }),

    handle(setHardwareVersionCompatibility, (state, action) => {
        return {
            ...state,
            hardwareVersionCompatibility: action.payload
        }
    }),
    handle(setDeviceVersionListResponse, (state, action) => {
        return {
            ...state,
            deviceVersionList: action.payload
        }
    }),
    handle(setAuthenticatedWithPinCode, (state, action) => {
        return {
            ...state,
            authenticatedWithPinCode: action.payload
        }
    }),
    handle(setSelectedBackgroundAction, (state, action) => {
        return {
            ...state,
            selectedBackgroundImage: action.payload
        }
    }),

    handle(setSystemRestartAction, (state, action) => {
        return {
            ...state,
            systemRestart: action.payload
        }
    }),

    handle(setRemoteUpdateConfig, (state, action) => {
        return {
            ...state,
            remoteUpdate: action.payload
        }
    }),

    handle(setWorkerConfigPanelAction, (state, action) => {
        return {
            ...state,
            workerConfigPanelSettings: action.payload
        }
    }),
    handle(setOnboardingListAction, (state, action) => {
        return {
            ...state,
            onboardingList: action.payload
        }
    })
    ,
    handle(setCloudStatus, (state, action) => {
        return {
            ...state,
            cloudEnabled: action.payload
        }
    })
    ,
    handle(setCloudConnectionStatusAction, (state, action) => {
        return {
            ...state,
            cloudEvent: action.payload
        }
    })
])
